import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IProjectAddressFieldsFragment = {
  address?: string | null
  bearing?: number | null
  pitch?: number | null
  zoom?: number | null
  city?: string | null
  country?: string | null
  createdAt?: any | null
  id?: any | null
  state?: string | null
  updatedAt?: any | null
  zipcode?: string | null
  projectId: any
  bounds?: {
    ne?: { lat: number; lng: number } | null
    sw?: { lat: number; lng: number } | null
  } | null
  center?: { lat: number; lng: number } | null
}

export type IGetProjectAddressQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetProjectAddressQuery = {
  projectAddresses?: {
    data: Array<{
      address?: string | null
      bearing?: number | null
      pitch?: number | null
      zoom?: number | null
      city?: string | null
      country?: string | null
      createdAt?: any | null
      id?: any | null
      state?: string | null
      updatedAt?: any | null
      zipcode?: string | null
      projectId: any
      bounds?: {
        ne?: { lat: number; lng: number } | null
        sw?: { lat: number; lng: number } | null
      } | null
      center?: { lat: number; lng: number } | null
    }>
  } | null
}

export type ISaveProjectAddressesMutationVariables = Types.Exact<{
  projectAddresses:
    | Array<Types.InputMaybe<Types.IProjectAddressInput>>
    | Types.InputMaybe<Types.IProjectAddressInput>
}>

export type ISaveProjectAddressesMutation = {
  saveManyProjectAddresses?: Array<{
    address?: string | null
    bearing?: number | null
    pitch?: number | null
    zoom?: number | null
    city?: string | null
    country?: string | null
    createdAt?: any | null
    id?: any | null
    state?: string | null
    updatedAt?: any | null
    zipcode?: string | null
    projectId: any
    bounds?: {
      ne?: { lat: number; lng: number } | null
      sw?: { lat: number; lng: number } | null
    } | null
    center?: { lat: number; lng: number } | null
  } | null> | null
}

export type IListenToProjectAddressSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenToProjectAddressSubscription = {
  projectAddress?: {
    id?: any | null
    item?: {
      address?: string | null
      bearing?: number | null
      pitch?: number | null
      zoom?: number | null
      city?: string | null
      country?: string | null
      createdAt?: any | null
      id?: any | null
      state?: string | null
      updatedAt?: any | null
      zipcode?: string | null
      projectId: any
      bounds?: {
        ne?: { lat: number; lng: number } | null
        sw?: { lat: number; lng: number } | null
      } | null
      center?: { lat: number; lng: number } | null
    } | null
  } | null
}

export const ProjectAddressFieldsFragmentDoc = gql`
  fragment ProjectAddressFields on ProjectAddress {
    address
    bearing
    bounds {
      ne {
        lat
        lng
      }
      sw {
        lat
        lng
      }
    }
    pitch
    zoom
    center {
      lat
      lng
    }
    city
    country
    createdAt
    id
    state
    updatedAt
    zipcode
    projectId
  }
`
export const GetProjectAddressDocument = gql`
  query GetProjectAddress($projectId: ObjectId!) {
    projectAddresses(projectId: $projectId, limit: 1) {
      data {
        ...ProjectAddressFields
      }
    }
  }
  ${ProjectAddressFieldsFragmentDoc}
`

/**
 * __useGetProjectAddressQuery__
 *
 * To run a query within a React component, call `useGetProjectAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAddressQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectAddressQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetProjectAddressQuery,
    IGetProjectAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetProjectAddressQuery,
    IGetProjectAddressQueryVariables
  >(GetProjectAddressDocument, options)
}
export function useGetProjectAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetProjectAddressQuery,
    IGetProjectAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetProjectAddressQuery,
    IGetProjectAddressQueryVariables
  >(GetProjectAddressDocument, options)
}
export type GetProjectAddressQueryHookResult = ReturnType<
  typeof useGetProjectAddressQuery
>
export type GetProjectAddressLazyQueryHookResult = ReturnType<
  typeof useGetProjectAddressLazyQuery
>
export type GetProjectAddressQueryResult = Apollo.QueryResult<
  IGetProjectAddressQuery,
  IGetProjectAddressQueryVariables
>
export const SaveProjectAddressesDocument = gql`
  mutation SaveProjectAddresses($projectAddresses: [ProjectAddressInput]!) {
    saveManyProjectAddresses(projectAddresses: $projectAddresses) {
      ...ProjectAddressFields
    }
  }
  ${ProjectAddressFieldsFragmentDoc}
`
export type ISaveProjectAddressesMutationFn = Apollo.MutationFunction<
  ISaveProjectAddressesMutation,
  ISaveProjectAddressesMutationVariables
>

/**
 * __useSaveProjectAddressesMutation__
 *
 * To run a mutation, you first call `useSaveProjectAddressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectAddressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectAddressesMutation, { data, loading, error }] = useSaveProjectAddressesMutation({
 *   variables: {
 *      projectAddresses: // value for 'projectAddresses'
 *   },
 * });
 */
export function useSaveProjectAddressesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveProjectAddressesMutation,
    ISaveProjectAddressesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveProjectAddressesMutation,
    ISaveProjectAddressesMutationVariables
  >(SaveProjectAddressesDocument, options)
}
export type SaveProjectAddressesMutationHookResult = ReturnType<
  typeof useSaveProjectAddressesMutation
>
export type SaveProjectAddressesMutationResult =
  Apollo.MutationResult<ISaveProjectAddressesMutation>
export type SaveProjectAddressesMutationOptions = Apollo.BaseMutationOptions<
  ISaveProjectAddressesMutation,
  ISaveProjectAddressesMutationVariables
>
export const ListenToProjectAddressDocument = gql`
  subscription ListenToProjectAddress($projectId: ObjectId!) {
    projectAddress(projectId: $projectId) {
      id
      item {
        ...ProjectAddressFields
      }
    }
  }
  ${ProjectAddressFieldsFragmentDoc}
`

/**
 * __useListenToProjectAddressSubscription__
 *
 * To run a query within a React component, call `useListenToProjectAddressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToProjectAddressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToProjectAddressSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenToProjectAddressSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToProjectAddressSubscription,
    IListenToProjectAddressSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToProjectAddressSubscription,
    IListenToProjectAddressSubscriptionVariables
  >(ListenToProjectAddressDocument, options)
}
export type ListenToProjectAddressSubscriptionHookResult = ReturnType<
  typeof useListenToProjectAddressSubscription
>
export type ListenToProjectAddressSubscriptionResult =
  Apollo.SubscriptionResult<IListenToProjectAddressSubscription>
